import { HttpClient, httpResource } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BehaviorSubject, map, Observable, tap } from 'rxjs';
import { Role } from '../models/models.lib';
import { SettingsService } from '../settings/settings.service';
import { ApiService } from '../api/api.service';
import { Settings } from '../common/obj.lib';
import { environment } from '../../environments/environment';
import { LoggerService } from '../shared/logger.service';
const { apiUrl } = environment;

export abstract class CasiRoleService extends BehaviorSubject<Array<any>> {
  public loading: boolean = false;
  // private settings: Settings = this.settingsService.getSettings();

  constructor(
    private http: HttpClient,
    // private settingsService: SettingsService
  ) {
    super([]);
  }

  public query(): void {
    this.fetch().subscribe((x) => {
      // console.log('query: x: ', x);
      return super.next(x);
    });
  }

  protected fetch(): Observable<Role[]> {
    this.loading = true;
    // this.settings = this.settingsService.getSettings();

    return this.http.get(encodeURI(`${apiUrl}/roles`))
      .pipe(
        map((response: any, i) => {
          // console.log('fetch:map:response: ', response, i);
          // let returning =<Role[]>response; // response.map(r =>  Role.create((r)));
          // console.log('fetch:map:response: ', returning);
          return <Role[]>response;
        }),
        map(r => r.map(x => Role.create(x))),
        // tap(nr => {
        //   console.log('nr: ', nr);
        // }),
        tap(() => (this.loading = false))
      )
  }
}

@Injectable({
  providedIn: 'root'
})
export class RolesService extends CasiRoleService {

  constructor(
    http: HttpClient,
    // private settingService: SettingsService,
    private apiService: ApiService,
    private logger: LoggerService
  ) {
    super(http);
  }

  createRolesResource() {
    return httpResource<Role[]>(() => (
      {
        url: `${apiUrl}/roles`,
        method: 'GET',
        withCredentials: true
      }
    ),
      {
        parse: (data) => {
          this.logger.debug(`parse:data: `, data);
          if (!data) {
            throw new Error('Invalid data received');
          }
          return Array.isArray(data) ? data.map(x => Role.create(x)) : [];
        }
      });
  }

  get() {
    return this.apiService.getHttpCall('roles', 'get');
  }

  getById(id: number): Promise<any> {
    return this.apiService.getHttpCallAsPromise(`roles/${id}`, 'getById');
  }

  add(p: any): Promise<any> {
    return this.apiService.postHttpCallAsPromise('roles', p, 'add');
  }

  update(p: any): Promise<any> {
    return this.apiService.putHttpCallAsPromise(`roles/${p.id}`, p, 'update');
  }

  destroy(id: number): Promise<any> {
    return this.apiService.deleteHttpCallAsPromise(`roles/${id}`, 'destroy');
  }

  destroyCheck(id: number): Promise<any> {
    return this.apiService.getHttpCallAsPromise(`rolescheck/${id}`, 'destroycheck');
  }

}
